import { EndorsementUuid } from '@converge/data';

const RETROACTIVE_DATE_ENDORSEMENT_UUIDS: EndorsementUuid[] = [
  EndorsementUuid.MediaEventLiability,
  EndorsementUuid.TechnologyErrorsAndOmissions,
];

export const shouldRenderRetroactiveDate = (
  endorsementUuid: string | null | undefined
): boolean =>
  RETROACTIVE_DATE_ENDORSEMENT_UUIDS.includes(
    endorsementUuid as EndorsementUuid
  );
